export enum TunifyColor {
    GREEN = "Green",
    BLUE = "Blue",
    ORANGE = "Orange",
  }